export default __webpack_public_path__ + "static/media/thumbnail_image_10.f24c4f5b.png";